import HomeOwner from "./components/short/HomeOwner.vue"
import PropertyType from "./components/short/PropertyType.vue"
import CurrentHomeInsurer from "./components/short/CurrentHomeInsurer.vue"
import YearBought from "./components/short/YearBought.vue"
import DateOfBirth from "./components/short/DateOfBirth.vue"
import FinalQuestions from "./components/short/FinalQuestions.vue"

const steps = {
    Short: {
        HomeOwner: HomeOwner,
        PropertyType: PropertyType,
        CurrentHomeInsurer: CurrentHomeInsurer,
        YearBought: YearBought,
        DateOfBirth: DateOfBirth,
        FinalQuestions: FinalQuestions
    }
};

export default {
    functional: true,
    props: {
        type: String,
        step: String
    },
    render(createElement, context) {
        // if (!steps[context.props.type][context.props.step]) {
        //     return createElement(steps["Pre"]["InsuranceType"], context.data, context.childred);
        // }
        return createElement(steps[context.props.type][context.props.step], context.data, context.children);
    }
}
